/**
 * Convert a number or string to alphanumeric dash string. Usually useful for setting an id or key based on a value.
 * @param stringOrNumber
 */
export function toAlphanumericDashString(stringOrNumber) {
  return "".concat(stringOrNumber).split(' ').join('-').replace(/[^a-zA-Z0-9\- ]/g, '').toLowerCase();
}
/**
 * @deprecated
 */

export var labelToId = toAlphanumericDashString;